import styled from 'styled-components';
import { BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  .headline-wrap {
    width: 100%;
    text-align: center;
    span {
      font-size: 26px;
      font-weight: bold;
    }
  }
  .search-wrap {
    padding-top: 32px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  .most-searched-wrap {
    padding-top: 20px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    button {
      margin-left: 32px;
      &:first-child {
        margin-left: 21px;
      }
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    .search-wrap {
      flex-direction: column;
      flex-wrap: wrap;
      button {
        width: 100%;
      }
    }
    .most-searched-wrap {
      flex-flow: row wrap;
      small {
        width: 100%;
        display: block;
        text-align: center;
      }
      button {
        margin-left: 0px;
        margin: 0 15px;
        &:first-child {
          margin-left: 0px;
        }
      }
    }
  }
`;

export const SearchInputSC = styled.input`
  margin-right: 24px;
  max-width: 100%;
  width: 390px;
  font-size: 16px;
  font-weight: normal;
  background: none;
  -webkit-appearance: none;
  border-radius: 12px;
  padding: 12px 20px;
  border: solid 1px rgba(38, 37, 53, 0.2);
  box-shadow: none;
  &:focus,
  &:active {
    box-shadow: none;
    outline: none;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
`;
